const en_US = {
  message : {
    welcomeMessage : 'Hello! Welcome to the data center of NAVER CLOUD PLATFORM.'
  }
}
export default en_US;